import { Popover, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

const STACK_PREFIX = "OfferCardEnterpriseStack";
export const stackClasses = {
  root: `${STACK_PREFIX}-root`,
  prefix: `${STACK_PREFIX}-prefix`,
  icon: `${STACK_PREFIX}-icon`,
  uppercase: `${STACK_PREFIX}-uppercase`,
};
export const OfferCardEnterpriseStack = styled(Stack)(({ theme }) => ({
  [`&.${stackClasses.root}`]: {
    flexDirection: "row",
    alignItems: "start",
    gap: theme.spacing(1),
    maxWidth: "100%",
    [`& .${stackClasses.prefix}`]: {
      flex: "0 0 auto",
    },
    [`& .${stackClasses.icon}`]: {
      fontSize: "18px",
      marginTop: 2,
    },
    [`& .${stackClasses.uppercase}`]: {
      textTransform: "uppercase",
    },
  },
}));

const POPOVER_PREFIX = "OfferCardEnterprisePopover";
export const popoverClasses = {
  root: `${POPOVER_PREFIX}-root`,
  textDescription: `${POPOVER_PREFIX}-textDescription`,
  textOriginalName: `${POPOVER_PREFIX}-textOriginalName`,
  uppercase: `${POPOVER_PREFIX}-uppercase`,
};
export const OfferCardEnterprisePopover = styled(Popover)(({ theme }) => ({
  [`&.${popoverClasses.root}`]: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(-5),
    "& .MuiPaper-root": {
      border: `solid 1px ${theme.palette.border.main}`,
      borderRadius: 0,
      padding: theme.spacing(2),
      maxWidth: "400px",
      [`& .${popoverClasses.textDescription}`]: {
        lineHeight: 1.2,
      },
      [`& .${popoverClasses.textOriginalName}`]: {
        paddingTop: theme.spacing(0.5),
      },
      [`& .${popoverClasses.uppercase}`]: {
        textTransform: "uppercase",
      },
    },
  },
}));
